import styled from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export const StyledSvg = styled.svg `
  fill: ${({ $inverted = false }) => $inverted ? theme.semantic.foreground.inverse : theme.semantic.foreground.primary};
`;
